/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/engine',['require','jquery','underscore','marionette','backbone','core/util','core/layouts/main-layout','json!content/json/global.json','core/navigation','modules/paging/paging','modules/bookmark/bookmark','modules/media/media','modules/editor/editor','modules/bugtracker/bugtracker','modules/cheats/cheats'],function(require) {
  'use strict';

  //////////////
  // IMPORTS //{
  //////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var Marionette = require('marionette');
  var Backbone = require('backbone');

  var Utilities = require('core/util');
  var MainLayout = require('core/layouts/main-layout');
  var global = require('json!content/json/global.json');

  // MODULES //

  var Navigation = require('core/navigation');

  var Paging = require('modules/paging/paging');
  var Bookmark = require('modules/bookmark/bookmark');

  var Media = require('modules/media/media');
  var Editor = require('modules/editor/editor');
  var Bugtracker = require('modules/bugtracker/bugtracker');
  var Cheats = require('modules/cheats/cheats');

  //var Achievement = require('modules/achievement/achievement');

  /*****************************************************************************************************************///}

  // patch jquery with custom util functions
  Utilities.jqueryPatch();

  // override default rendering function
  Backbone.Marionette.Renderer.render = function(template, data)
  {
    var html;

    try
    {
      ////console.log('trying render', template, data);
      html = template(data);
      ////console.log('html', html);
    }
    catch (err)
    {
      console.error('Error: Data mismatch on template', err);
      Engine.viewport.$el.find('#connection-alert-holder').show();
      html = 'Template Load Error.';//this.template();
    }

    return html;
  };

  // create the engine
  var Engine = new Marionette.Application({
    config: { },
    radio: Backbone.Wreqr.radio.channel('global').vent,
    urlParams: { },
    query: Utilities.getQueryParameters(),
    viewport: null
  });

  /////////////
  // MODULES /{
  /////////////

  Engine.module('Navigation', Navigation);
  Engine.module('Media', Media);
  Engine.module('Bookmark', Bookmark);
  Engine.module('Paging', Paging);
  Engine.module('Bugtracker', Bugtracker);
  Engine.module('Editor', Editor);
  Engine.module('Cheats', Cheats);
  //Engine.module('Achievement', Achievement);

  /*****************************************************************************************************************///}

  ///////////////////
  // INITIALIZERS //{
  ///////////////////

  Engine.on('before:start', function(options)
  {
    ////console.log('Engine::importSettings');

    //console.log('Config: ', options);
    console.warn('User Agent:', navigator.userAgent.toLowerCase());
    this.config = options;

    // set title
    try {
      window.top.document.title = options.info.client + ' ›› ' + options.info.course;
    }
    catch (err) {
      console.error('Cannot set document title');
    }

    var layoutOptions = { model: new Backbone.Model(global) };
    _.assign(layoutOptions, options.layout);

    // show main layout
    this.viewport = new MainLayout(layoutOptions);
  });

  Engine.on('start', function(options)
  {
    var startDate = new Date();
    var loadDurationMS = startDate.getTime() - window.startLoadTimestamp;
    if (loadDurationMS >= 30000)
    {
      Engine.radio.trigger('slow.connection');
    }

    //console.warn('engine start', window.startLoadTimestamp, startDate.getTime(), );

    if (Backbone.history)
      Backbone.history.start({ pushState: false });
  });

  /*****************************************************************************************************************///}

  ////////////
  // EVENTS /{
  ////////////

  Engine.radio.on('load.pageobject', function(object)
  {
    if (!Engine.config.settings.reloadSame && Engine.module('Paging').currentPage === object)
    {
      //console.log('Notice: config.setting.reloadSame set to false, disregarding loadPage call.');
      return;
    }

    //console.log('Engine::loadPageObject');

    //var page = object.current(); changed to always start at beginning
    var page = (Engine.config.settings.moduleProgress) ? object.current() : object.first();

    // listen for ready event
    Engine.listenToOnce(page, 'page.ready', function(e)
    {
      //console.log('Creating view and adding to viewport', page);
      $('html').removeClass('course-loading');

      var view = page.create();

      if (!page.get('inOverlay'))
      {
        //console.log('adding to pageholder');
        Engine.viewport.pageHolder.show(view);
        Engine.viewport.overlays.empty();

        page.setActive();

        Engine.trigger('page.loaded', page);

        if (page.id === 'menu')
        {
          Engine.radio.trigger('check.menu.actions');
          Engine.radio.trigger('test.bandwidth');
        }
      }
      else
      {
        //console.log('adding to overlays', view.page.get('view'));
        Engine.viewport.overlays.show(view);
        Engine.viewport.$el.find('.genome-viewport').attr('data-overlay', page.get('layout'));

        //if (view.page.get('view') === 'overlays/module-summary')
        Engine.module('Paging').finishedModule = null;
      }

    });

    Engine.radio.trigger('check.connection', null, 0);
    // load the page
    page.load();
  });

  Engine.radio.on('page.overlay.close', function(data)
  {
    //alert('close overlay');
    //console.log('close overlays');
    Engine.viewport.$el.find('.genome-viewport').attr('data-overlay', '');
    Engine.viewport.overlays.empty();
    if (Engine.module('Paging').currentPage.id === 'menu')
    {
      Engine.radio.trigger('check.menu.actions');
    }
    else
    {
      Engine.viewport.pageHolder.currentView.setInterface();
      console.warn('Close Overlay');//.content.setInterface();
    }
  });

  Engine.radio.on('go.home', function(object)
  {
    ////console.log('Engine::goHome');
    Engine.radio.trigger('load.pageobject', object);
  });

  Engine.radio.on('screen.complete', function(data)
  {
    ////console.log('Engine::screenComplete');
    if (data.noNext)
      return;

    Engine.radio.trigger('ui.update', { next: true });
  });

  Engine.radio.on('set.bookmark', function(data)
  {
    //console.log('Engine::setBookmark');

    data = data || { datachunk: Engine.module('Paging').serialize(true) };

    // should this trigger an event instead with the serialized object as passed data?
    Engine.module('Bookmark').save(data);
  });

  Engine.radio.on('paging.loaded', function(data)
  {
    ////console.log('Engine::pagingLoaded');
    Engine.viewport.begin();
    // set title
    try {
      window.top.document.title = Engine.module('Paging').map.courseInfo.courseCompany + ' ›› ' + Engine.module('Paging').map.courseInfo.courseTitle;
    }
    catch (err) {
      console.error('Cannot set document title', err);
    }

    Engine.module('Navigation').start();
  });

  Engine.radio.on('check.menu.actions', function()
  {
    console.log('check menu action');
    //$('#caption-holder').hide();
    /*var $finishedModule = Engine.module('Paging').finishedModule;
    Engine.radio.trigger('ui.update', { badge: true });
    if ($finishedModule)
    {
      ////console.log('finished module found', $finishedModule);
      var $summaryID = $finishedModule.get('summaryID') || 'module_summary';
      var $summaryPage = Engine.module('Paging').find($summaryID);
      ////console.log('summary page', $summaryPage);
      Engine.module('Navigation').go($summaryPage);
      return;
    }
    else if (Engine.module('Paging').playingGame)
    {
      Engine.module('Paging').playingGame = false;
      //loadGamesOverlay();
      Engine.module('Navigation').go('games_overlay');
      return;
    }
    else */
    if (Engine.module('Paging').allModulesComplete() && !Engine.module('Paging').courseComplete)
    //else if (true && !Engine.module('Paging').courseComplete)
    {
      //var $conclusionAnimation = Engine.config.mapSettings.conclusionPage || 'conclusion_animation';
      var $courseComplete = Engine.config.mapSettings.completePage || 'course_complete';
      ////console.log('MODS COMPLETE, COURSE NOT', Engine.module('Paging').find('conclusion_animation'));
      /*if (!Engine.module('Paging').find($conclusionAnimation).get('complete'))
      {
        Engine.module('Navigation').go($conclusionAnimation);
      }
      else
      {
      }*/
      Engine.module('Paging').setCourseComplete();
      //Engine.module('Achievement').setAchievementCompleteByCode('course_complete');
      Engine.module('Navigation').go($courseComplete);
      //loadPageAsOverlay(_pagingArray.courseCompletePage);
      return;
    }
    else if (Engine.module('Paging').courseComplete)
    {
      Engine.module('Paging').setCompleteDate(); // confirmation check for older versions that didn't have a date

      Engine.viewport.pageHolder.currentView.checkCertificate();
      //loadMenu();
    }
    // var $oPage;
    // var $modArr = Module.instancesArr;
    // var $mod;
    /*var $oPage = Engine.module('Paging').checkCompleteOverlay();
    if ($oPage)
    {
      //console.log('completeoverlay', $oPage);
      Engine.module('Navigation').go($oPage);
    }*/
  });

  Engine.radio.on('check.connection', function(callback, retryCount)
  {
    callback = callback === undefined ? null : callback;
    retryCount = retryCount === undefined ? 1 : retryCount;
    console.warn('Checking connection...');
    var d = new Date();

    require(['text!index.html?rand=' + d.getTime()], function(data) {
      if (!data || data === '')
      {
        Engine.radio.trigger('connection.fail', callback, retryCount);
      }
      else
      {
        console.warn('Connection test successful');
        if (callback !== null)
          callback();
      }
    }, function(a, b) {
      Engine.radio.trigger('connection.fail', callback, retryCount);
    });
  });

  Engine.radio.on('connection.retry', function(callback, retryCount)
  {
    console.warn('Retrying connection in 2 seconds');
    retryCount++;
    _.delay(function() {
      console.warn('Retrying...');
      Engine.radio.trigger('check.connection', callback, retryCount);
    }, 2000);
  });

  Engine.radio.on('connection.fail', function(callback, retryCount)
  {
    if (retryCount >= 3)
    {
      Engine.radio.trigger('connection.final');
    }
    else
    {
      Engine.radio.trigger('connection.retry', callback, retryCount);
    }
  });

  Engine.radio.on('connection.final', function()
  {
    console.error('Connection test failed 3 consecutive times. Showing error.');
    Engine.viewport.$el.find('#connection-alert-holder').show();
    Engine.module('Media').stop({all: true});
  });

  Engine.radio.on('test.bandwidth', function()
  {
    // bandwidth test here
    var bwTester = window.BD_TESTER || document.BD_TESTER;
    if (!bwTester)
      return;

    bwTester.testBandwidth(function(bandwidth, testValues) {
      var minBandwidth = 190; //250

      // Standard Deviation of Results
      //var standardDeviation = bwTester.calculateDeviation(bandwidth, testValues);

      if (console && console.log) {
        //console.log('Custom Method');
        //console.log('Estimated Bandwidth : ' + bandwidth);
        //console.log('Deviation : ' + standardDeviation);
        //console.log('Total : ' + (bandwidth - standardDeviation));
        //console.log('Requests : ' + testValues);
      }
      console.warn('Bandwidth test complete:', bandwidth);
      if (bandwidth < minBandwidth) {
        //$('#bandwidth-message').html(BD_TESTER.connMessage);
        //$('#bandwidth-message').show();
        //$('#connection-slow-holder').show();
        Engine.radio.trigger('slow.connection');
      }

      $('#pre-loading').hide();
    });
  });

  Engine.radio.on('slow.connection', function()
  {
    Engine.viewport.$el.find('#connection-slow-holder').show();
    Engine.viewport.$el.find('#connection-slow-holder').one('click', function() {
      $(this).hide();
    });
  });

  /*Engine.radio.on('achievement.show', function(achObj)
  {
    Engine.viewport.showAchievement(achObj);
  });*/

  Engine.radio.on('minigame.unlock.show', function(minigamePage)
  {
    Engine.viewport.showMinigameUnlock(minigamePage);
  });

  Engine.radio.on('print.cert', function()
  {
    var $url = 'content/certificate/cert_complete.html';
    var $fullName = Engine.module('Bookmark').data.username;
    var $nameArr = $fullName.split(',');
    var $var = {};

    if ($nameArr.length === 2)
    {
      $var.fname = _.trim($nameArr[1]);// 'first';
      $var.lname = _.trim($nameArr[0]);// 'last';
    }
    else
    {
      $var.fname = $fullName;// StringUtils.trim($nameArr[1]);// 'first';
      $var.lname = '';// StringUtils.trim($nameArr[0]);// 'last';
    }

    //var d = new Date();
    $var.date = Engine.module('Paging').completionDate;//(d.getMonth() + 1) + '/' + (d.getDate()) + '/' + (d.getFullYear());

    $var.token = 'p8a0cq4lia';
    $var.title = Engine.module('Paging').map.courseInfo.courseTitle;//Engine.config.info.course;

    window.open($url + '?' + $.param($var), 'certWin', 'resizable=1, scrollbars=1');
  });

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

  /*****************************************************************************************************************///}

  return Engine;

});

